var _rect, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFooterTwitter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "url(#pattern0)",
    fillOpacity: 0.7
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_6_1386",
    transform: "scale(0.05)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_6_1386",
    width: 20,
    height: 20,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAAAXNSR0IArs4c6QAAAdtJREFUOE/FlDGIE1EQhv9/E02ZIFoYFA4Lm7NTG0E7QcRKCKKdZN8SOSsrsdBnJ1gGLmEnS7A6K4s7DksLUVA8EK8VBAkIJ2Kj4mH2jbzghlySNRc4uGmW3Zn59p95M4/YY+Me87C/QGttsdfrXQBwRFU3kiT5mFVorQ2stW6oMIqiG3EcrwDQaW0wxpwEsAbAP70pyWXn3IcgCM5Xq9Wb1tr+EGiM+UnyWalUCpvN5vYYlMaYTQCLU372g+QjAKtxHG9mQJ/wG8BBAO9JNuI4fpMlh2F4muS7vANU1U6n04kGqrMgY8w6gMsjSS8ArJB8SXLBOfc8B/hJRE5kvgGwVqsVyuXyFZItAEfnHKUNETmzA+hfjDHfAFQABHMCn4rI9WnAhwDuzwnz4bdEpD0B9GVXKpXHAG4DOLBL8Ha/3z/e7Xa/TgD9hyiK7vrqVXXY5BngZRFZGo3ZsXqNRmMhTdNXAKq7UPilWCwutlqt77nAfyoPO+eWSIYAjuWAfwG4KCKvx/3jlwPr9frZQqFwR1Wv5cC2nHNXkyTxlUzYAOj3VFUfkPSD7Udnmv1R1Sdpmt4bPYT/KjTGnFPVSyRPATgEwK/jZ5JvgyBYbbfbW7N6u7/34Sx13v8X/v6fFRJqXhsAAAAASUVORK5CYII="
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterTwitter);
export default __webpack_public_path__ + "static/media/footer_twitter.926eaa6a310e248621bcaa9f6321040a.svg";
export { ForwardRef as ReactComponent };